import { humanize } from '@/modules/simulator/ui/text';
import { num, str } from './verdict-readers';

/** The live Shadow criteria, using the judge's recorded values and the compared replies. */
export function ShadowComparison({ comparison, aiReply, humanReply }: {
  comparison: Record<string, unknown>;
  aiReply?: string;
  humanReply?: string;
}) {
  const text = (key: string) => {
    const value = str(comparison[key]);
    return value ? humanize(value) : 'Not recorded';
  };
  const score = (key: string) => {
    const value = num(comparison[key]);
    return value === null ? 'Not recorded' : `${value}%`;
  };
  const rows = [
    ['Tone', text('humanTone'), text('aiTone')],
    ['Sentiment', text('humanSentiment'), text('aiSentiment')],
    ['Personalization', score('personalizationScoreHuman'), score('personalizationScoreAi')],
    ['Completeness', score('completenessScoreHuman'), score('completenessScoreAi')],
    ['Length', humanReply ? `${humanReply.length} characters` : 'Not recorded', aiReply ? `${aiReply.length} characters` : 'Not recorded'],
  ];
  return (
    <div className='flex flex-col gap-4'>
      <div className='overflow-x-auto rounded-lg border border-gray-500'>
        <table className='w-full text-left text-body-sm' aria-label='Shadow response analytics'>
          <thead className='bg-gray-100 text-gray-900'>
            <tr>{['Criteria', 'Human Agent', 'Kim AI'].map((heading) => <th key={heading} scope='col' className='px-3 py-2 font-medium'>{heading}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map(([label, human, ai]) => (
              <tr key={label} className='border-t border-gray-500 text-text-body'>
                <th scope='row' className='px-3 py-2 font-medium'>{label}</th>
                <td className='px-3 py-2'>{human}</td>
                <td className='px-3 py-2'>{ai}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {['Instructions Used', 'Knowledge Used'].map((label) => (
        <details key={label} className='rounded-lg border border-gray-500 px-3 py-2 text-body-sm'>
          <summary className='cursor-pointer font-medium text-text-heading'>{label}</summary>
          <p className='pt-2 text-gray-900'>Not recorded for this run.</p>
        </details>
      ))}
    </div>
  );
}
